module.exports = __webpack_public_path__ + "static/media/08.529a838e.jpg";